import React, { useContext } from "react";
import { Context } from "../../../utils/context";

const Common_Ad_Banner = ({ imgSrc }) => {

  const { imageUrl } = useContext(Context);

  return (
    <div className="adimg_div">
      {imgSrc?.map((item) => {
        return (
          <div className="img_div">
            <img
              src={imageUrl + item}
              className="right_img"
            />
          </div>
        );
      })}
    </div>
  );
};

export default Common_Ad_Banner;
